export default __webpack_public_path__ + "static/media/2079_01A.3bf12355.jpg";